export const DESKTOP_BREAKPOINT = `(min-width: 960px)`;
export const MOBILE_BREAKPOINT = `(max-width: 959px)`;

export const MAX_SCREEN_SIZE = 1440;
export const BREAKPOINT_SIZE = 960;
export const MIN_SCREEN_SIZE = 320;
